import ip from "ip";

let iputils = {
    bufferToBinary: function (buffer) {
        return buffer[0].toString(2).padStart(8, '0') + '.' + buffer[1].toString(2).padStart(8, '0') + '.' + buffer[2].toString(2).padStart(8, '0') + '.' + buffer[3].toString(2).padStart(8, '0');
    },
    stringToBinary: function (str) {
        return this.bufferToBinary(ip.toBuffer(str));
    },
    isNetIPClass: function(ipclass) {
        return ((ipclass == 'A') || (ipclass == 'B') || (ipclass == 'C'));
    },
    isValidIP: function (ipaddr) {
        return ip.isV4Format(ipaddr);
    },
    getClassFromIP: function(ipaddr) {
        if (this.isValidIP(ipaddr)) {
            var ipbytes = ip.toBuffer(ipaddr);
            if ((ipbytes[0] & 128) == 0) {
                return 'A';
            } else {
                if ((ipbytes[0] & 64) == 0) {
                    return 'B';
                } else {
                    if ((ipbytes[0] & 32) == 0) {
                        return 'C';
                    } else {
                        if ((ipbytes[0] & 16) == 0) {
                            return 'D';
                        } else {
                            return 'E';
                        }
                    }
                }
            }
        } else {
            return '';
        }
    },
    getCIDRSubnet: function(ipaddr, cidr) {
        return ip.cidrSubnet("" + ipaddr + "/" + cidr);
    },
    getMaskSubnet: function(ipaddr, ipmask) {
        return ip.subnet(ipaddr, ipmask);
    },
    getDefaultMaskForClass: function(ipclass) {
        switch (ipclass) {
            case 'A':
                return '255.0.0.0';
            case 'B':
                return '255.255.0.0';
            case 'C':
                return '255.255.255.0';
            default:
                return '';
        }
    },
    stringToLong: function (ipaddr) {
        return ip.toLong(ipaddr);
    },
    longToString: function(ipaddr) {
        return ip.fromLong(ipaddr);
    }


}

export default iputils;